module.exports = __webpack_public_path__ + "static/media/conn_point_production_comparative_per_day.389f3414.svg";